import React from 'react';
import Banner from '../components/banner/Banner.js';
import CoinsTable from '../components/CoinsTable.js';

const HomePage = () => {
    return (
        <>
        <Banner />
        <CoinsTable />
        </>
    );
};

export default HomePage;